import { render, staticRenderFns } from "./ChangePartner.vue?vue&type=template&id=150d0b40&"
import script from "./ChangePartner.vue?vue&type=script&lang=js&"
export * from "./ChangePartner.vue?vue&type=script&lang=js&"
import style0 from "./ChangePartner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports